import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
function Loading() {
    return <div className="h-screen flex items-center justify-center">
        <Spin indicator={
            <LoadingOutlined
                style={{
                    fontSize: "100px",
                    color: 'white'
                }}
                spin
            />
        } />
    </div>
}
export default Loading